import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { FormService } from '../../shared/form.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { filter, catchError, debounceTime, distinctUntilChanged, tap, finalize } from 'rxjs/operators';
import { SharedService } from '../../shared/shared.service';
import { Subscription, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ConsentPopUpComponent } from '../consent-pop-up/consent-pop-up.component';
import { TrackService } from 'src/app/services/track.service';
import { LoadedFromCPService } from 'src/app/shared/loaded-from-customer-portal.service';


interface IXOptions {
  stepIndex: number;
  progress: number;
  footerContent?: string;
  leftButtonsList?: [];
  rightButtonsList?: [];
  outlet?: any;
  backArrow?: any;
  formDisabled?: boolean;
  newCar: boolean;
}

const XDefaults: IXOptions = {
  stepIndex: 0,
  progress: 0,
  footerContent: '',
  leftButtonsList: [],
  rightButtonsList: [],
  backArrow: null,
  outlet: null,
  formDisabled: false,
  newCar: false
};

@Component({
  selector: 'app-consents',
  templateUrl: './consents.component.html',
  styleUrls: ['./consents.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsentsComponent implements OnInit, AfterViewInit, AfterContentInit {
  parentForm;
  hideFirstConsent;
  hasRegistration;
  private subscriptionRegistered: Subscription;
  data: any = {
    oportunity: "consent.oportunity",
    privacy2: "consent.privacy2",
    privacy1: "consent.privacy1",
    privacy: "consent.privacy",
    aditional: "consent.aditional",
    declareThat1: "consent.declareThat1",
    myhome: "consent.myhome",
    conditionsKnown: "consent.conditionsKnown",
    conditionsAgree: 'consent.conditionsAgree',
    conditions: 'consent.conditions',
    acquainted: 'consent.acquainted',
    declareThat: 'consent.declareThat',
    formGroupName: 'agreement',
    title: 'consent.title',
    heading: 'consent.heading',
    image: 'woman-with-laptop-taking-picture-of-document',
    rightPaddingBottom: '52px',
    first: 'consent.first',
    first1: 'consent.first1',
    first2: 'consent.first2',
    second: 'consent.second',
    third: 'consent.third',
    third1: 'consent.third1',
    required: 'consent.required',
    agree: 'consent.agree',
    disagree: 'consent.disagree',
    errorMessage: 'consent.errorMessage',
    fourth: 'consent.fourth',
    fifth: 'consent.fifth',
    fifth2: 'consent.fifth2',
    failOnline: "consent.failOnline",
    newFirst: "consent.newFirst",
    newSecond: "consent.newSecond",
    newThird: "consent.newThird",
    additionalInfo:"consent.additionalInfo",
    newSecond1: "consent.newSecond1",
    newSecond12: "consent.newSecond12",
    newSecond2: "consent.newSecond2",
    newSecond3: "consent.newSecond3",
    newSecond4: "consent.newSecond4",
    newSecond5: "consent.newSecond5",
    newSecond6: "consent.newSecond6",
    newSecond7: "consent.newSecond7",
    newSecond8: "consent.newSecond8",
    newSecond9: "consent.newSecond9",
    newSecond10: "consent.newSecond10",
    yesPlease: "consent.yesPlease",
    noThankYou: "consent.noThankYou",
    readMore: "consent.readMore",
    yesIDo: "consent.yesIDo",
    popUpDataMarketing: "consent.popUpDataMarketing",
    popUpDataMarketing1: "consent.popUpDataMarketing1",
    popUpDataMarketing2: "consent.popUpDataMarketing2",
    productDetails: "consent.productDetails",
    productDetails1: "consent.productDetails1",
    productDetails2: "consent.productDetails2",
    productDetails3: "consent.productDetails3",
    productDetails4: "consent.productDetails4",
    productDetails5: "consent.productDetails5",
    stepIndex: 3, progress: 0.5,
    footerWithPrice: true,
    rightButtonsList: [{
      disabled: true,
      text: 'footer.continue',
      link: 'payment',
    }],
  };
  trigger: boolean = false;
  trigger1: boolean = false;
  consentPopUp: NxModalRef<ConsentPopUpComponent, any>;
  onlyMtpl: any;
  over14days:boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    public formService: FormService,
    public loadedFromCPService: LoadedFromCPService,
    public sharedService: SharedService,
    public trackService: TrackService,
    public http: HttpClient,
    public dialogService: NxDialogService,
    public formBuilder: FormBuilder) {
    this.parentForm = formService.currentForm;
    // console.log(this.parentForm.controls.isMTPL.value);

    // this.onlyMtpl = this.parentForm.controls.onlyMtpl.value;

    let formData = this.formService.currentForm.getRawValue();
    if (Math.abs(moment(moment()).diff(formData.insuranceStart, 'days')) >= 14)
      this.hideFirstConsent = true;
    else
      this.hideFirstConsent = false;


    let data = this.route.data['value'];
    if (data) {
      this.updateControl(data);
    } else {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          data = this.route.snapshot?.data;
          this.updateControl(data);
        });
    }
  }


  readMore(trigger) {
    if (trigger == "trigger") {
      this.trigger = !this.trigger;
    }
    if (trigger == "trigger1") {
      this.trigger1 = !this.trigger1;
    }
    if (trigger == 'B1') {
      this.sharedService.setConsentsFlag('B1')
      this.consentPopUp = this.dialogService.open(ConsentPopUpComponent, {
        data: {
          popUpDataMarketing: 'consent.popUpDataMarketing',
          popUpDataMarketing1: 'consent.popUpDataMarketing1',
          popUpDataMarketing2: 'consent.popUpDataMarketing2',
          productDetails: 'consent.productDetails',
          productDetails1: 'consent.productDetails1',
          productDetails2: 'consent.productDetails2',
          productDetails3: 'consent.productDetails3',
          productDetails4: 'consent.productDetails4',
          productDetails5: 'consent.productDetails5',
          onlyMtpl: false,

          firstName: 'callAgent.firstName',
          lastName: 'callAgent.lastName',
          mobilePhone: 'callAgent.phone',
          heading: 'callAgent.heading',
          subHeading: 'callAgent.subHeading',
          btnOkText: 'callAgent.btnOkText',
          agent: true,
          hasRegistration: this.hasRegistration
        }, showCloseIcon: true
      });
    }
    if (trigger == 'B2') {
      this.sharedService.setConsentsFlag('B2')
      this.consentPopUp = this.dialogService.open(ConsentPopUpComponent, {
        data: {
          popUpDataMarketing: 'consent.popUpDataMarketing',
          popUpDataMarketing1: 'consent.popUpDataMarketing1',
          popUpDataMarketing2: 'consent.popUpDataMarketing2',
          productDetails: 'consent.productDetails',
          productDetails1: 'consent.productDetails1',
          productDetails2: 'consent.productDetails2',
          productDetails3: 'consent.productDetails3',
          productDetails4: 'consent.productDetails4',
          productDetails6: 'consent.productDetails6',
          productDetails5: 'consent.productDetails5',

          firstName: 'callAgent.firstName',
          lastName: 'callAgent.lastName',
          mobilePhone: 'callAgent.phone',
          heading: 'callAgent.heading',
          subHeading: 'callAgent.subHeading',
          btnOkText: 'callAgent.btnOkText',
          agent: true,
          hasRegistration: this.hasRegistration
        }, showCloseIcon: true
      });
    }

  }

  // private markFormGroupTouched(formGroup: FormGroup) {
  //   (<any> Object).values(formGroup.controls).forEach(control => {
  //     control.markAsUntouched();

  //     if (control.controls) {
  //       this.markFormGroupTouched(control);
  //     }
  //   });
  // }

  trackByIndex(index: number) {
    return index;
  };

  ngAfterViewInit() {
    ['question1', 'question2', 'question3', 'question4'].map(item => {
      this.parentForm?.controls?.agreement?.controls?.[item]?.valueChanges.subscribe(value => {
        if (value === false) {
          this.parentForm.controls.agreement.controls[item].patchValue(null, {
            onlySelf: true,
            emitEvent: false,
            emitModelToViewChange: true
          });
        }
      });
    });
  }

  ngAfterContentInit() {
    // this.markFormGroupTouched(this.formService.currentForm);
  }

  legalAcceptance(path, value){
    value = String(value)
    this.trackService.pushEventTracking(path,value)
  }


  updateControl(snapshotData) {
    Object.assign(this.data, snapshotData);
  }

  ngOnInit(): void {

    this.parentForm = this.formService.currentForm;
    if(this.parentForm?.controls?.samePerson?.value == 'Y') {
        this.checkIfUsersRegistered(this.parentForm?.controls?.ownerData?.controls?.egn?.value)
    }
    else {
      this.checkIfUsersRegistered(this.parentForm?.controls?.policyholderData?.controls?.egn?.value);
    }
    this.over14days=this.getDays();
    // this.markFormGroupTouched(this.formService.currentForm);
    let snapshotData: any = this.route.snapshot?.data;
    this.updateControl(snapshotData);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        snapshotData = this.route.snapshot?.data;
        this.updateControl(snapshotData);
      });
  }

  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  getDays(){
    let values = this.formService.getMainForm().getRawValue();
    var startDate:any = values.insuranceStart;
    const today:any = new Date();
    if(typeof(startDate)=='string'){
       startDate = new Date(startDate)
    }
    if((startDate-today)/(1000*60*60*24)>14){
      return true;
    }
    else return false
    
  }

  myFilter(search, itemValue) {
    if (!search) {
      return itemValue.match(new RegExp('^1', 'g')) !== null;
    }
    return itemValue.match(new RegExp('^' + search, 'g')) !== null;
  }


  checkIfUsersRegistered(egn){
   this.subscriptionRegistered = this.loadedFromCPService.isUserRegistered(egn)
    .subscribe(
      (registrationStatus) => {
        console.log(registrationStatus)
        this.hasRegistration = registrationStatus;
      },
      (error) => {
        console.error('Error:', error);
      }
    );
  }

  ngOnDestroy (){
    if(this.subscriptionRegistered){
      this.subscriptionRegistered.unsubscribe()
    }
  }

}
